import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/new/45.png';
import _imports_1 from '../../../assets/new/29.png';
const _withScopeId = n => (_pushScopeId("data-v-3301568f"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"header\" data-v-3301568f>填写真实信息</div><div class=\"step\" data-v-3301568f><div class=\"active\" data-v-3301568f>1.填写学校</div><img src=\"" + _imports_0 + "\" data-v-3301568f><div data-v-3301568f>2.选择年级班级</div><img src=\"" + _imports_0 + "\" data-v-3301568f><div data-v-3301568f>3.填写姓名</div></div>", 2);
const _hoisted_3 = {
  class: "search"
};
const _hoisted_4 = {
  class: "cells"
};
const _hoisted_5 = {
  class: "left"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "省份", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
})], -1));
const _hoisted_8 = {
  class: "left"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "城市", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
})], -1));
const _hoisted_11 = {
  class: "left"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "区", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
})], -1));
const _hoisted_14 = {
  class: "left"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "学段", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
})], -1));
const _hoisted_17 = {
  class: "left"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "学校", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
})], -1));
import { ref, onMounted, reactive, computed } from "vue";
import { useStore } from "vuex";
import { userCityList, userSchoolList } from "../../../api/index";
import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
export default {
  __name: 'schoolMes_copy',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const safeMes = computed(() => store.state.safeMes);
    const userInfo = computed(() => store.state.userInfo);
    // ------------------------------------------
    const provincePicker = ref(false);
    const cityPicker = ref(false);
    const sectionPicker = ref(false);
    const schoolPicker = ref(false);
    const areasPicker = ref(false);
    const provinceName = ref("");
    const cityName = ref("");
    const areasName = ref("");
    const sectionName = ref("");
    // ---------------------------------------------
    let schoolPeriod = ""; //学段值
    let nowPeriod = ""; //年级id
    let class_id = 0; //班级id
    const schoolData = reactive({
      name: "",
      id: ""
    }); // 学校值
    const area = reactive({
      data: []
    }); // 地区值
    // ---------------------------------------------
    const school = ["小学", "初中", "高中", "大学"]; // 学段
    const schoolList = reactive({
      data: []
    }); // 学校
    const provinceList = reactive({
      data: []
    }); // 省
    const cityList = reactive({
      data: []
    }); // 市
    const regionList = reactive({
      data: []
    }); // 区

    const next = () => {
      const formData = {
        province_id: area.data[0],
        city_id: area.data[1],
        county_id: area.data[2],
        school_id: schoolData.id,
        school_name: schoolData.name,
        school_type: schoolPeriod,
        grade_id: nowPeriod,
        class_id: class_id
      };
      console.log(formData);
      if (!formData.province_id || !formData.city_id || !formData.county_id || !formData.school_type || !formData.school_id) {
        ElMessage.error("请选择完整哦");
      } else {
        if (route.query.type) {
          router.push({
            name: "classMes",
            params: {
              ...formData
            },
            query: {
              type: route.query.type
            }
          });
        } else {
          router.push({
            name: "classMes",
            params: {
              ...formData
            }
          });
        }
      }
      console.log(formData);
    };
    const getProvinceVal = data => {
      provinceName.value = data.name;
      provincePicker.value = false;
      cityName.value = "";
      areasName.value = "";
      getAreaData(data.id, 1);
      sectionName.value = "";
      schoolPeriod = "";
      schoolData.name = "";
      schoolData.id = "";
    };
    const getCityVal = data => {
      cityName.value = data.name;
      cityPicker.value = false;
      areasName.value = "";
      getAreaData(data.id, 2);
      sectionName.value = "";
      schoolPeriod = "";
      schoolData.name = "";
      schoolData.id = "";
    };
    const getRegionVal = data => {
      areasName.value = data.name;
      area.data.splice(2, 1, data.id);
      areasPicker.value = false;
      sectionName.value = "";
      schoolPeriod = "";
      schoolData.name = "";
      schoolData.id = "";
    };
    const sectionChange = data => {
      console.log(data);
      sectionPicker.value = false;
      sectionName.value = data;
      let arr = ["X", "C", "G", "D"];
      schoolPeriod = arr[school.indexOf(data)];
      getSchoolList();
      schoolData.name = "";
      schoolData.id = "";
    };
    const selectFinalSchool = data => {
      schoolPicker.value = false;
      schoolData.name = data.name;
      schoolData.id = data.id;
    };
    const getSchoolList = () => {
      if (area.data.findIndex(v => v === 0) !== -1 || !schoolPeriod) return ElMessage.info("请先选择完地区和学习阶段哦");
      let obj = {
        ...safeMes.value,
        city_id: area.data[2],
        school_type: schoolPeriod
      };
      userSchoolList(JSON.stringify(obj)).then(res => {
        let data = res.data;
        if (data.code) return store.commit("judgeCode", {
          code: data.code,
          msg: data.msg
        });
        schoolList.data = data.data;
      }).catch(() => {
        return ElMessage.error("获取学校列表失败");
      });
    };
    const getAreaData = (data0, type = 0) => {
      let obj = {
        parentid: data0,
        ...safeMes.value
      };
      userCityList(encodeURIComponent(JSON.stringify(obj))).then(res => {
        let data = res.data;
        if (data.code) return ElMessage.error(data.msg);
        if (!type) {
          provinceList.data = data.data;
        } else if (type === 1) {
          regionList.data = [];
          cityList.data = data.data;
          //	数组响应式
          console.log(data0);
          console.log(cityList.data[0].id);
          area.data.splice(0, 1, data0);
          area.data.splice(1, 1, cityList.data[0].id);
          area.data.splice(2, 1, 0);
          console.log(area.data);
        } else {
          regionList.data = data.data;
          area.data.splice(1, 1, data0);
          area.data.splice(2, 1, regionList.data[0].id);
        }
      }).catch(() => {});
    };
    onMounted(() => {
      if (userInfo.value && localStorage.getItem("ways") === "wechat") {
        nowPeriod = "X1s";
        class_id = 1;
      }
      if (localStorage.getItem("title")) {
        document.title = localStorage.getItem("title");
      }
      console.log(userInfo.value);
      if (userInfo.value.hasSchoolInfo) {
        nowPeriod = userInfo.value.grade_id;
        class_id = userInfo.value.class_id;
        schoolPeriod = userInfo.value.school_type;
        provinceList.data = userInfo.value.province_list;
        cityList.data = userInfo.value.city_list;
        regionList.data = userInfo.value.county_list;
        schoolData.id = userInfo.value.school_id;
        schoolData.name = userInfo.value.school_name;
        area.data.splice(0, 1, userInfo.value.province_id);
        area.data.splice(1, 1, userInfo.value.city_id);
        area.data.splice(2, 1, userInfo.value.county_id);
        provinceList.data.forEach(item => {
          if (item.id === userInfo.value.province_id) {
            provinceName.value = item.name;
          }
        });
        cityList.data.forEach(item => {
          if (item.id === userInfo.value.city_id) {
            cityName.value = item.name;
          }
        });
        regionList.data.forEach(item => {
          if (item.id === userInfo.value.county_id) {
            areasName.value = item.name;
          }
        });
        let arr = ["X", "C", "G", "D"];
        sectionName.value = school[arr.indexOf(schoolPeriod)];
      } else {
        getAreaData(1);
      }
      getSchoolList();
    });
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_picker = _resolveComponent("van-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc'])
      }, [_createElementVNode("div", null, [_hoisted_1, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("a", {
        href: "javascript: void(0)",
        class: "cell",
        onClick: _cache[0] || (_cache[0] = $event => provincePicker.value = true)
      }, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createTextVNode(" " + _toDisplayString(provinceName.value), 1)]), _hoisted_7]), _createElementVNode("a", {
        href: "javascript: void(0)",
        class: "cell",
        onClick: _cache[1] || (_cache[1] = $event => cityPicker.value = true)
      }, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createTextVNode(" " + _toDisplayString(cityName.value), 1)]), _hoisted_10]), _createElementVNode("a", {
        href: "javascript: void(0)",
        class: "cell",
        onClick: _cache[2] || (_cache[2] = $event => areasPicker.value = true)
      }, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createTextVNode(" " + _toDisplayString(areasName.value), 1)]), _hoisted_13]), _createElementVNode("a", {
        href: "javascript: void(0)",
        class: "cell",
        onClick: _cache[3] || (_cache[3] = $event => sectionPicker.value = true)
      }, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createTextVNode(" " + _toDisplayString(sectionName.value), 1)]), _hoisted_16]), _createElementVNode("a", {
        href: "javascript: void(0)",
        class: "cell",
        onClick: _cache[4] || (_cache[4] = $event => schoolPicker.value = true)
      }, [_createElementVNode("div", _hoisted_17, [_hoisted_18, _createTextVNode(" " + _toDisplayString(schoolData.name), 1)]), _hoisted_19])]), _createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        onClick: next,
        style: {
          "width": "80%",
          "margin": "1rem auto"
        }
      }, {
        default: _withCtx(() => [_createTextVNode("下一步")]),
        _: 1
      })])])], 2), _createVNode(_component_van_popup, {
        show: provincePicker.value,
        "onUpdate:show": _cache[6] || (_cache[6] = $event => provincePicker.value = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          title: "请选择省份",
          columns: provinceList.data,
          onConfirm: getProvinceVal,
          onCancel: _cache[5] || (_cache[5] = $event => provincePicker.value = false),
          "columns-field-names": {
            text: 'name',
            value: 'id'
          }
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: cityPicker.value,
        "onUpdate:show": _cache[8] || (_cache[8] = $event => cityPicker.value = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          title: "请选择城市",
          columns: cityList.data,
          onConfirm: getCityVal,
          onCancel: _cache[7] || (_cache[7] = $event => cityPicker.value = false),
          "columns-field-names": {
            text: 'name',
            value: 'id'
          }
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: areasPicker.value,
        "onUpdate:show": _cache[10] || (_cache[10] = $event => areasPicker.value = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          title: "请选择区",
          columns: regionList.data,
          onConfirm: getRegionVal,
          onCancel: _cache[9] || (_cache[9] = $event => areasPicker.value = false),
          "columns-field-names": {
            text: 'name',
            value: 'id'
          }
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: sectionPicker.value,
        "onUpdate:show": _cache[12] || (_cache[12] = $event => sectionPicker.value = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          title: "请选择学段",
          columns: school,
          onConfirm: sectionChange,
          onCancel: _cache[11] || (_cache[11] = $event => sectionPicker.value = false)
        })]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: schoolPicker.value,
        "onUpdate:show": _cache[14] || (_cache[14] = $event => schoolPicker.value = $event),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          title: "请选择学校",
          columns: schoolList.data,
          onConfirm: selectFinalSchool,
          onCancel: _cache[13] || (_cache[13] = $event => schoolPicker.value = false),
          "columns-field-names": {
            text: 'name',
            value: 'id'
          }
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};